<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base">
    <div class="mt-40">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1 d-inline-block">
                {{ 'Discover Clients' }}
              </h4>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="w-100 client_dashboard">
          <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Discovered Past Clients" aria-label="pastClients">
              <app-past-clients></app-past-clients>
            </mat-tab>
            <mat-tab label="Expired Listings" aria-label="Expired Listings" *ngIf="displayExpiredListings && isAgent">
              <app-expired-listings></app-expired-listings>
            </mat-tab>
          </mat-tab-group>
          <!-- Tabs end-->
        </div>
      </div>
    </div>
  </div>
</div>
